module.exports = __webpack_public_path__ + "img/ai_resume_white.a2e48677.svg";